import { render, staticRenderFns } from "./PaymentDashboard.vue?vue&type=template&id=43be4d76&scoped=true"
import script from "./PaymentDashboard.vue?vue&type=script&lang=js"
export * from "./PaymentDashboard.vue?vue&type=script&lang=js"
import style0 from "./PaymentDashboard.vue?vue&type=style&index=0&id=43be4d76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43be4d76",
  null
  
)

export default component.exports